module.exports = __webpack_public_path__ + "static/media/saneel_sreeni.9728138e.jpg";